import * as api from "./../api/index";
import { FETCH_ALL, POST, DELETE, UPDATE, SORT } from "./../constants/action_types";

export const getPosts = () => async (dispatch) => 
{
  try
  {
    const { data } = await api.fetchPosts();
    dispatch({ type: FETCH_ALL, payload: data });
  }
  catch (err)
  {
    console.log(err);
  }
}

export const createPost = (post) => async (dispatch) =>
{
  try
  {
    const { data } = await api.createPost(post);
    dispatch({ type: POST, payload: data });
  }
  catch (err)
  {
    console.log(err);
  }
}

export const updatePost = (id, post) => async (dispatch) =>
{
  try
  {
    const { data } = await api.updatePost(id, post);
    dispatch({ type: UPDATE, payload: data });
  }
  catch (err)
  {
    console.log(err);
  }
}

export const deletePost = (id) => async (dispatch) =>
{
  try
  {
    //duh delete doesn't fucking return anything that's why it wasn't working
    await api.deletePost(id);
    dispatch({ type: DELETE, payload: id });
  }
  catch (err)
  {
    console.log(err);
  }
}

export const sortPosts = (posts, descending) => async (dispatch) =>
{
  dispatch({ type: SORT, payload: { data: posts, descending: descending } });
}